import React, {useContext, useEffect, useState} from 'react';
import 'components/FindVinForm/FindVinForm.css';
import {Form, useActionData, useNavigate} from 'react-router-dom';
import {findReportsByFormData} from 'lib/find-vin-api';
import VinInput from 'components/UI/Input/VinInput';
import EngineDisplacementInput from 'components/UI/Input/EngineDisplacementInput';
import SelectYearInput from 'components/UI/Input/SelectYearInput';
import SearchInAllDatabases from 'components/UI/Input/SearchInAllDatabases';
import InfoPopper from 'components/UI/Popper/InfoPopper';
import T from 'i18n-react';
import {vinMaxLength} from 'lib/utils/vinUtils';
import Button from "@mui/material/Button";
import {FindVinFormDataContext} from "./FindVinFormDataProvider";
import {Backdrop, CircularProgress} from "@mui/material";

const FindVinForm = ({isSubmitting, setSelectedDatabases}) => {

    const navigate = useNavigate();
    const actionData = useActionData();
    const [isDatabasesSwitchChecked, setIsDatabasesSwitchChecked] = useState(true);
    const {vinFieldValue, setVinFieldValue, year, setYear, engineCC, setEngineCC} = useContext(FindVinFormDataContext);

    const minYear = 1990;
    const maxYear = new Date().getFullYear();

    useEffect(() => {
        if (actionData?.requestCompleted) {
            navigate(`/reports`, {
                state: {
                    vin: actionData.vin,
                    reportData: actionData.data,
                    engineCC: engineCC,
                    firstRegistrationDate: year?.year(),
                }
            });
        }
    }, [actionData, navigate, engineCC, year]);

    return (
        <div>
            {isSubmitting ? <Backdrop
                sx={{zIndex: 50000}}
                open={isSubmitting}
            >
                <CircularProgress color={'primary'} size={150}/>
            </Backdrop> : null}
            <Form className="findVinForm" method={'post'} action={'/find-vin'} id='findVinForm'>
                <div className="controlVinForm">
                    <label>{T.translate('carDataComponent.vin')}<span className="vinStarLabel">*</span></label>
                    <VinInput vinMaxLength={vinMaxLength}
                              vinFieldValue={vinFieldValue}
                              setVinFieldValue={setVinFieldValue}
                    />
                </div>
                <div className="controlVinForm">
                    <div className="control-labels-vinForm">
                        <label>{T.translate('carDataComponent.engineCC')}</label>
                        <InfoPopper size={'small'}
                                    message={T.translate('vinQueryComponent.engineCCTitle')}/>
                    </div>
                    <EngineDisplacementInput form={'findVinForm'} setEngineCC={setEngineCC} engineCC={engineCC}/>
                </div>
                <div className="controlVinForm">
                    <div className="control-labels-vinForm">
                        <label>{T.translate('carDataComponent.registrationYear')}</label>
                        <InfoPopper size={'small'}
                                    message={T.translate('vinQueryComponent.registrationYearTitle')}/>
                    </div>
                    <SelectYearInput minYear={minYear} maxYear={maxYear} year={year}
                                     setYear={setYear} form={'findVinForm'}
                    />
                </div>
                <SearchInAllDatabases onSelectDatabasesManually={setSelectedDatabases}
                                      isSubmitting={isSubmitting}
                                      vinFieldValue={vinFieldValue}
                                      vinMaxLength={vinMaxLength}
                                      isDatabasesSwitchChecked={isDatabasesSwitchChecked}
                                      setIsDatabasesSwitchChecked={setIsDatabasesSwitchChecked}
                                      year={year}
                                      engineCC={engineCC}
                                      form={'findVinForm'}
                />
                <Button className={`getReportButton ${isDatabasesSwitchChecked ? 'inactive' : 'active'}`}
                        disabled={isSubmitting || vinFieldValue.length < vinMaxLength}
                        variant={'contained'}
                        type={'submit'}
                        form={'findVinForm'}
                >{T.translate("vinQueryComponent.getReport")}</Button>
            </Form>
        </div>
    );
};

export default FindVinForm;

export const findReportsAction = () => {
    return async ({request}) => {
        const formData = await request.formData();
        return await findReportsByFormData(formData);
    };
};
